export default "__VITE_ASSET__DulShoP$__"